import React from "react";
import { connect, ConnectedProps } from "react-redux";
import * as OrganizationsActions from "modules/organizations/OrganizationsState";
import Authorization, { Features } from "modules/auth/Authorization";
import ReportsContainer from "pages/reports/bi-dashboard/Reports.page.container";
import ReportsNextContainer from "pages/reports/bi-dashboard-next/Reports.page";

const mapStateToProps = (state: any) => ({
  currentUser: state.users.currentUser,
  activeOrganization: OrganizationsActions.getActiveOrganization(state),
  federationData: state.organizations.federationData,
  featureData: OrganizationsActions.getFeatureData(state),
});

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;
const ReportsFeatureComponent: React.FC<PropsFromRedux> = ({
  currentUser,
  activeOrganization,
  federationData,
  featureData,
}) => {
  const auth = new Authorization(
    currentUser,
    activeOrganization,
    federationData,
    featureData,
  );

  return auth.hasFeatures([Features.BI_DASHBOARD_NEXT]) ? (
    <ReportsNextContainer currentUser={currentUser} />
  ) : (
    <ReportsContainer />
  );
};

const ConnectedReportsFeatureComponent = connector(ReportsFeatureComponent);

const ReportsConditionalContainer = () => {
  return <ConnectedReportsFeatureComponent />;
};

export default ReportsConditionalContainer;
